enum NotificationType {
  DocumentManagement = 'Document Management',
  ProjectManagement = 'Project Management',
}

export default NotificationType
